import { Component, computed, effect, input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RadioButtonComponent } from '../../../../../../shared/components/forms/radio-button/radio-button.component';
import { templateDrivenFormsViewProviders } from '../../../../../../shared/directives/form.directive';
import { ClaimType } from '../../../../../mmr/mmr.types';

@Component({
  selector: 'app-claim-type-selection',
  imports: [RadioButtonComponent, FormsModule],
  templateUrl: './claim-type-selection.component.html',
  styleUrl: './claim-type-selection.component.scss',
  viewProviders: [templateDrivenFormsViewProviders],
  host: {
    class: 'full-width',
  },
})
export class ClaimTypeSelectionComponent {
  claimTypes = input.required<ClaimType[]>();

  formValue = input.required<any>();

  submittingValue = input.required<boolean>();

  formSubmitted = input.required<boolean>();

  formValid = output<boolean>();

  valid = signal(false);

  private viewModel = computed(() => {
    return {
      submittingValue: this.submittingValue(),
      claimTypes: this.claimTypes(),
      formValue: this.formValue(),
      formSubmitted: this.formSubmitted(),
      formValid: this.valid(),
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor() {
    effect(() => {
      this.valid.set(!!this.vm.formValue?.['claim-type']);
      this.formValid.emit(this.valid());
    });
  }

  claimTypesTitles: { [key: string]: string } = {
    Breakdown: 'It broke down by itself',
    'Damage Caused by Accident': 'It was damaged by accident',
    Maintenance: 'Maintenance',
  };
}
